import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import AccountingConnection from '../../entities/accountingConnection';
export function deleteAccountingConnection(accountingConnection: AccountingConnection, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = accountingConnection.id;}
const _work = workingSet();




accountingConnection.status = 'D';
accountingConnection.addedOn = newHRTimestamp();
accountingConnection.addedBy = getCurrentUserId();
accountingConnection.importSource = targetImportSource;
accountingConnection.importId = mergeId;
store.dispatch(Actions.AccountingConnectionActions.removeAccountingConnectionQueue(accountingConnection));
}


